import { render, staticRenderFns } from "./TarifasView.vue?vue&type=template&id=77f98bae&scoped=true"
import script from "./TarifasView.vue?vue&type=script&lang=js"
export * from "./TarifasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f98bae",
  null
  
)

export default component.exports